import { useContext } from "react";

import { ActivityLogsContext } from "../contexts/ActivityLogsContext";

const useActivityLogsContext = () => {
  const context = useContext(ActivityLogsContext);

  if (!context) throw new Error("Context must be use inside AuthProvider");

  return context;
};

export default useActivityLogsContext;
